<template>
  <div class="cover">
    <div class="need-sub-trigger" @click="openModal">
      <slot></slot>
    </div>

    <Modal :is-modal-active="isModalVisible || active" card @close="closeModal">
      <template #title>
        {{ $t("need_sub.title") }}
      </template>

      <div class="need-sub-icon">
        <FontAwesomeIcon :icon="['fas', 'key']" />
        <FontAwesomeIcon class="need-sub-icon__plus" :icon="['fas', 'plus']" />
      </div>

      <p class="info">
        {{ $t("need_sub.benefits") }}
      </p>

      <RippleButton
        class="unlock-btn"
        type="prime"
        @click="handleSubscriptionLink"
      >
        {{ $t("need_sub.get_access") }}
      </RippleButton>

      <a class="cancel-link" @click.prevent="closeModal">
        {{ $t("cancel") }}
      </a>
    </Modal>
  </div>
</template>

<script setup>
import { ref, defineEmits, nextTick } from "vue";
import RippleButton from "../common/form/Button.vue";
import Modal from "./Modal.vue";
import { useRoute, useRouter } from "vue-router";

const emit = defineEmits(["close"]);

const route = useRoute();
const router = useRouter();

const isModalVisible = ref(false);

const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});

const handleSubscriptionLink = async () => {
  closeModal();
  emit("close");
  await router.push({ path: "/subscriptions", hash: `#sub_id` });
};

function openModal() {
  isModalVisible.value = true;
}

function closeModal() {
  isModalVisible.value = false;
}
</script>
<style lang="scss" scoped>
.cover {
  overflow-y: auto;
  overflow-x: hidden;
}
/* в lock-режиме обёртка делается layout-прозрачной: в разметке остаётся только
   .lock-slot (ведёт себя как исходный контрол), поэтому nav/иконки не сдвигаются */
.cover.lock,
.cover.lock .need-sub-trigger {
  display: contents;
}
.need-sub-icon {
  position: relative;
  display: inline-block;
  font-size: 46px;
  color: var(--brand-color);
  line-height: 1;
}
.need-sub-icon__plus {
  position: absolute;
  right: 0em;
  top: 65%; /* справа, ниже центра — как на макете */
  font-size: 0.45em;
}
.info {
  text-align: center;
  margin: 0;
  color: var(--font-color);
}
.unlock-btn {
  width: 100%;
  height: 56px;
}
.cancel-link {
  color: var(--font-color);
  text-decoration: underline;
  opacity: 0.65;
  cursor: pointer;
}
</style>
